import authErrors from "constants/firebaseAuthErrors";
import { FirebaseError } from "firebase/app";

export const getErrorMessage = (error: unknown) => {
  let msg = "Unknown Error";

  if (error instanceof FirebaseError) {
    const error_code = error.code.split("/");
    msg = authErrors[error_code[1]];
    if (typeof msg === "undefined") {
      msg = error.message;
    }
  } else if (error instanceof Error) {
    msg = error.message;
  }

  return msg;
};
